export const generateHeadlineKey = (
	headline: string,
	index: number,
): string => {
	return `${index}-${headline
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/(^-|-$)/g, "")}`
}

export const generateUrlName = (title?: string): string => {
	const res = (title ?? "")
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/(^-|-$)/g, "")
	return res === "" ? "untitled" : res
}

export const formatHtmlContentForSearch = (content: string): string => {
	return content
		.replaceAll(/<iframe.*?src="(.*?)".*?>/g, " $1 ")
		.replaceAll(/<[^>]*>/g, " ")
		.replaceAll(/\s+/g, " ")
		.trim()
}
